const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

export const ENV = process.env.REACT_APP_ENV;
export const SESSION_ID = params.sessionId;

let API_DOMAIN = '';
if (process.env.REACT_APP_ENV === 'dev') {
  API_DOMAIN = 'http://localhost:1337';
} else if (process.env.REACT_APP_ENV === 'uat') {
  API_DOMAIN = 'https://uat.api.ezchats.com';
} else if (process.env.REACT_APP_ENV === 'prod') {
  API_DOMAIN = 'https://api.ezchats.com';
}

export const INPUT_SYNC_API_URL = `${API_DOMAIN}/session-inputs/${SESSION_ID}`;
export const INIT_SYNC_API_URL = `${API_DOMAIN}/session-inputs/${SESSION_ID}/init`;
export const HISTORY_API = `${API_DOMAIN}/session-history/${SESSION_ID}`;
export const ENROLLMENT_API_URL = `${API_DOMAIN}/products/risrx/${SESSION_ID}/enrollment`;
export const CHECK_EXISTING_ACCOUNT = `${API_DOMAIN}/products/risrx/${SESSION_ID}/enrollment`;
